import { Link } from "react-router-dom";
import SEOMeta from "@/components/SEOMeta";
import NavbarNew from "@/components/NavbarNew";
import FooterNew from "@/components/FooterNew";
import { services } from "@/data/services";
import { Photo } from "@/components/shared/Photo";

const Servicos = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOMeta
        title="Serviços"
        description="Sites, sistemas sob medida, automação com IA e consultoria para pequenas e médias empresas. Escopo, processo e investimento de cada frente."
        canonicalUrl="/servicos"
      />
      <NavbarNew />

      <main>
        <div className="mx-auto max-w-[1000px] px-8 pb-[90px] pt-[76px] max-[900px]:px-5">
          <h1 className="max-w-[620px] text-[44px] font-bold leading-[1.1] tracking-[-0.04em] [text-wrap:balance] max-[900px]:text-[38px]">
            Tecnologia só faz sentido se resolve um problema
          </h1>
          <p className="mt-[18px] max-w-[560px] text-[16.5px] leading-[1.65] text-muted-foreground">
            Três frentes de trabalho, todas com o mesmo objetivo: tirar peso do seu dia e fazer o
            negócio render mais.
          </p>

          <div className="mt-11 flex flex-col gap-4">
            {services.map((service) => (
              <div
                key={service.slug}
                id={service.slug}
                className="scroll-mt-24 rounded-[20px] border border-border bg-card p-8 shadow-card"
              >
                <div className="grid grid-cols-[1fr_240px] items-start gap-8 max-[900px]:grid-cols-1 max-[900px]:gap-5">
                  <div>
                    <div className="flex flex-wrap items-center gap-3">
                      <span className="inline-flex h-[26px] items-center rounded-full bg-accent px-3 text-[11.5px] font-bold text-primary">
                        {service.tag}
                      </span>
                    </div>
                    <h2 className="mt-4 text-[25px] font-bold tracking-[-0.03em]">
                      {service.title}
                    </h2>
                    <p className="mt-3 max-w-[640px] text-[15.5px] leading-[1.7] text-muted-foreground">
                      {service.description}
                    </p>
                  </div>
                  <div className="aspect-[4/3] overflow-hidden rounded-[14px] border border-border max-[900px]:order-first max-[900px]:aspect-[16/9]">
                    <Photo id={service.photo} sizes="(max-width: 900px) 100vw, 240px" />
                  </div>
                </div>

                <div className="mt-[22px] grid grid-cols-[repeat(auto-fit,minmax(240px,1fr))] gap-[11px]">
                  {service.features.map((feature) => (
                    <div key={feature} className="flex items-start gap-[11px]">
                      <span className="mt-0.5 text-xs font-bold text-primary">✓</span>
                      <span className="text-[13.5px] leading-[1.55] text-muted-foreground">
                        {feature}
                      </span>
                    </div>
                  ))}
                </div>

                <div className="mt-[26px] flex flex-wrap items-center justify-between gap-4 border-t border-border pt-5">
                  <span className="max-w-[400px] text-[12.5px] text-muted-foreground">
                    {service.priceNote}
                  </span>
                  <Link
                    to={service.ctaHref ?? "/contato"}
                    className="inline-flex h-[42px] items-center rounded-full bg-primary px-5 text-[13.5px] font-bold text-primary-foreground transition hover:brightness-95"
                  >
                    {service.cta}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      <FooterNew />
    </div>
  );
};

export default Servicos;
